// extracted by mini-css-extract-plugin
export var createdDate = "_nm-1";
export var divider = "_nm-2";
export var headerDivider = "_nm-3";
export var messagesCard = "_nm-0";
export var messagesContainer = "_nm-7";
export var messagesContainerWrapper = "_nm-4";
export var pointerCapturingButtonBoxes = "_nm-a";
export var showLeftPanelButton = "_nm-9";
export var showMoreButton = "_nm-c";
export var showMoreButtonContainer = "_nm-b";
export var summaryTitle = "_nm-6";
export var systemMessageCardWrapper = "_nm-d";
export var topButtons = "_nm-8";
export var withPadding = "_nm-5";